import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import WaveSurfer from 'wavesurfer.js';
import MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js';
export default defineComponent({
  name: 'MicroPhone',
  props: {
    ready: {
      type: Boolean,
      default: false
    }
  },
  setup: function (props) {
    var microPhoneRef = ref();
    var microError = ref(true);
    var microErrorText = ref('');
    var wavesurfer;
    var start = function () {
      if (microPhoneRef.value) {
        wavesurfer = WaveSurfer.create({
          container: microPhoneRef.value,
          waveColor: '#5B98F7',
          height: 50,
          interact: false,
          cursorWidth: 0,
          barHeight: 4,
          barMinHeight: 2,
          barWidth: 4,
          barRadius: 2,
          barGap: 2,
          plugins: [MicrophonePlugin.create()]
        });
        wavesurfer.microphone.on('deviceReady', function () {
          microError.value = false;
        });
        wavesurfer.microphone.on('deviceError', function (e) {
          microError.value = true;
          microErrorText.value = '麦克风检测异常，请检查设备';
        });
        wavesurfer.on('error', function () {
          microError.value = true;
        });
        wavesurfer.microphone.start();
      }
    };
    onUnmounted(function () {
      if (wavesurfer) {
        wavesurfer.stop();
        wavesurfer.destroy();
      }
    });
    onMounted(function () {
      watch(function () {
        return props.ready;
      }, function () {
        if (props.ready) {
          start();
        }
      });
    });
    return {
      microPhoneRef: microPhoneRef,
      microError: microError,
      microErrorText: microErrorText
    };
  }
});